import * as React from 'react';
import clsx from 'clsx';

import { getErrorDisplayText } from './inputHelpers';
import Fieldset from '../components/forms/Fieldset';

export interface RadiobuttonGroupProps {
  error?: string | object;
  hasError?: boolean;
  children?: React.ReactNode;
  hint?: string;
  className?: string;
  label?: string;
}

/**
 * @deprecated
 * Plase see ui folder of your project
 * Use `RadiobuttonGroup` to have a set of radio buttons.
 *
 * ```js
 * import { RadiobuttonGroup } from '.';
 * ```
 */
export const RadiobuttonGroup = React.memo(
  ({ error, hasError, className, children, hint, label }: RadiobuttonGroupProps) => {
    return (
      <div className={clsx('InputContainer RadioButtons RadioButtons--default', className)}>
        <Fieldset tab-index={0} label={label} modifierClassName="RadioButtons--fieldSet">
          {children}
        </Fieldset>
        {hint && (
          <div className="Hints">
            <div className="Hint">{hint}</div>
          </div>
        )}
        {hasError && (
          <div className="Errors">
            <div className="Error">{getErrorDisplayText(error)}</div>
          </div>
        )}
      </div>
    );
  }
);
